// src/botsData.js
const TEAM_META = {
  teamName: "Afterparty BotLabs Dev Team",
  teamBlurb:
    "Built and maintained by the Afterparty BotLabs team — performance, reliability, great UX.",
  teamAvatar: "/images/team-logo.png",
  teamUrl: "/about",
};

const bots = [
  {
    id: "afterparty-groovy",
    name: "Afterparty Groovy Music",
    description: "The ultimate music bot for Discord.",
    details:
      "Afterparty Groovy Music streams high-quality audio from Spotify, YouTube, and more — with playlists, filters, and seamless 24/7 playback to enhance your Discord server.",
    invite:
      "https://discord.com/api/oauth2/authorize?client_id=1086511506922946650&permissions=8&scope=bot",
    voteUrl: "https://top.gg/bot/1086511506922946650/vote",
    website: "https://botlabs-xyz.github.io/afterparty-groovy-music/",
    websiteLabel: "Docs",
    image: "/images/afterparty-groovy.png",

    creator: {
      name: "Diwas Atreya",
      image: "https://github.com/diwasatreya.png",
      details: "Original creator of the Afterparty Groovy Music bot.",
      url: "https://github.com/diwasatreya",
    },

    ...TEAM_META,
  },
  {
    id: "versa",
    name: "Versa",
    description: "Moderation, roles, automation, and analytics—built to scale.",
    details:
      "Versa is a powerful and modular Discord bot that enhances server management and engagement with advanced tools, automation, and interactive features.",
    invite:
      "https://discord.com/api/oauth2/authorize?client_id=1200483261533650966&permissions=8&scope=applications.commands+bot",
    voteUrl: "https://top.gg/bot/1200483261533650966/vote",
    links: [
      { label: "Website", url: "https://botversa.xyz" },
      { label: "Docs", url: "https://help.botversa.xyz/" },
    ],
    showWebsite: true,
    showWebsiteInShowcase: true,
    image: "/images/versa.png",

    creator: "FeaKH#6229",
    creatorDetails:
      "Lead developer behind these bots, specializing in automation and Discord integrations.",
    creatorImage: "/images/feakh.png",

    ...TEAM_META,
  },
  {
    id: "verifybot",
    name: "VerifyBot",
    description: "Simple, reliable verification for Discord servers.",
    details:
      "VerifyBot provides secure age/user verification, ban alerts, and role assignment. Ideal for 18+ and community-focused servers to manage trusted access and user risk.",
    invite:
      "https://discord.com/oauth2/authorize?client_id=1325944440778657873&permissions=2953309377&integration_type=0&scope=bot+applications.commands",
    voteUrl: "https://top.gg/bot/1325944440778657873/vote",
    website: "https://botlabs-xyz.github.io/Verify-Bot-docs/",
    websiteLabel: "Docs",
    image: "/images/verify-bot.png",

    creator: "FeaKH#6229",
    creatorDetails:
      "Lead developer behind these bots, specializing in automation and Discord integrations.",
    creatorImage: "/images/feakh.png",

    ...TEAM_META,
  },
  {
    id: "voice-maestro",
    name: "VoiceMaestro",
    description:
      "Smart temporary voice channels—create when needed, vanish when idle.",
    details:
      "VoiceMaestro by Afterparty: Effortlessly create temporary voice channels for fluid and dynamic communication in your server. Perfect for events, gaming, and spontaneous conversations.",
    invite:
      "https://discord.com/api/oauth2/authorize?client_id=1165878496879452170&permissions=8&scope=applications.commands%20bot",
    voteUrl: "https://top.gg/bot/1165878496879452170/vote",
    website: "http://voicemaestro.xyz",
    showWebsite: true,
    image: "/images/voice-maestro.png",

    creator: "FeaKH#6229",
    creatorDetails:
      "Lead developer behind these bots, specializing in automation and Discord integrations.",
    creatorImage: "/images/feakh.png",

    ...TEAM_META,
  },
  {
    id: "lofi-vibes",
    name: "Lofi Vibes",
    description: "24/7 lofi music with curated playlists.",
    details:
      "Lofi Vibes is a relaxing music bot for Discord, offering a variety of lofi tracks and playlists to help you focus, study, or chill out. Enjoy smooth, uninterrupted streaming!",
    invite:
      "https://discord.com/api/oauth2/authorize?client_id=1194219710351429683&permissions=8&scope=applications.commands+bot",
    voteUrl: "https://top.gg/bot/1194219710351429683/vote",
    website: "https://botlabs-xyz.github.io/lofi-vibes/",
    websiteLabel: "Docs",
    image: "/images/lofi-vibes.png",

    creator: {
      name: "n1cho",
      image: "/images/n1cho.png",
      details: "Specialized in Lofi and radio bots. Developer of Lofi Vibes.",
      url: "https://www.fiverr.com/samusken1cho123",
    },

    ...TEAM_META,
  },
  {
    id: "novapulse",
    name: "NovaPulse",
    description:
      "Advanced Discord moderation, verification, logging, automation, and server security tools.",
    details:
      "NovaPulse brings moderation, verification, logging, automation, and server security tools together to help communities stay organized and protected.",
    invite:
      "https://discord.com/oauth2/authorize?client_id=1354663481021829150",
    voteUrl: "https://top.gg/bot/1354663481021829150",
    links: [
      { label: "Docs", url: "https://botlabs-xyz.github.io/novapulse-docs/" },
      { label: "Support", url: "https://discord.gg/BusuZp2G8w" },
      { label: "Website", url: "https://afterpartylabs.xyz" },
    ],
    image: "/images/NovaPulse.png",

    creator: "FeaKH#6229",
    creatorDetails:
      "Lead developer behind these bots, specializing in automation and Discord integrations.",
    creatorImage: "/images/feakh.png",

    ...TEAM_META,
  },
];

export default bots;
